  /*============Brand Bar Controller
  ================================*/
  angular
      .module('vppApp')
      .controller('promoTileController', promoTileController);

    promoTileController.$inject = ['$scope', 'promoTileFactory', '$stateParams', 'vppConfig'];

    function promoTileController($scope, promoTileFactory, $stateParams, vppConfig){
      promoTileFactory().then(function (response) {
        $scope.tiles = response.data.promos;
        $scope.items = $scope.tiles.items;
        
      });
  };